import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { SettingsInterestRateStore } from 'src/stores/SettingsStores/SettingsInterestRateStore/SettingsInterestRateStore';

export const InterestRateDetails = observer(() => {
    return (
        <EntityPresentation
            store={SettingsInterestRateStore}
            entityName="setting-interest-rate"
        />
    );
});
